module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/326.c73b3d36.png";